import {
  CHANGE_CURRENT_TAB,
  LOAD_TAB_REQUEST,
  LOAD_TAB_FAIL,
  LOAD_TAB_SUCCESS,
  FETCH_MORE_REQUEST,
  FETCH_MORE_FAIL,
  FETCH_MORE_SUCCESS,
  LOAD_DISCOVERY_TIMELINES_REQUEST,
  LOAD_DISCOVERY_TIMELINES_FAIL,
  LOAD_DISCOVERY_TIMELINES_SUCCESS,
} from 'shared/exploreActions';
import _ from 'underscore';

function convertFeedItemsToStore(feedItems, oldFeedState, currentTab) {
  const oldFeedItems = oldFeedState[currentTab.timelineKey] || [];
  const newFeedItems = _.map(feedItems, f => {
    return {feedContentId: f.content.feedContentId, isSponsored: f.isSponsored};
  });

  let newResults = oldFeedItems.concat(newFeedItems);
  newResults = _.uniq(newResults);

  const newFeedState = oldFeedState;
  newFeedState[currentTab.timelineKey] = newResults;
  return newFeedState;
}

export default function exploreTabs(state = {
  currentTab: {},
  feedItems: {},
}, action) {
  switch (action.type) {
  case LOAD_DISCOVERY_TIMELINES_REQUEST:
    {
      return {
        ...state,
        loadingDiscoveryTimelines: true,
      };
    }
  case LOAD_DISCOVERY_TIMELINES_FAIL:
    {
      return {
        ...state,
        loadingDiscoveryTimelines: false,
      };
    }
  case LOAD_DISCOVERY_TIMELINES_SUCCESS:
    {
      const { discoveryTimelines } = action.payload;
      return {
        ...state,
        discoveryTimelines,
        loadingDiscoveryTimelines: false,
      };
    }
  case CHANGE_CURRENT_TAB:
    {
      const { tab: currentTab } = action.payload;

      return {
        ...state,
        currentTab,
      };
    }
  case FETCH_MORE_REQUEST:
    {
      const { tab: currentTab } = action.payload;
      const { isFetching } = state;
      isFetching[currentTab.timelineKey] = true;

      return {
        ...state,
        currentTab,
        isFetching: Object.assign({}, isFetching),
      };
    }
  case LOAD_TAB_REQUEST:
    {
      const { tab: currentTab } = action.payload;
      const { isFetching } = state;
      isFetching[currentTab.timelineKey] = true;

      return {
        ...state,
        currentTab,
        isFetching: Object.assign({}, isFetching),
      };
    }
  case LOAD_TAB_FAIL:
  case FETCH_MORE_FAIL:
    {
      const { tab: failedTab } = action.payload;
      const { isFetching } = state;
      isFetching[failedTab.timelineKey] = false;

      return {
        ...state,
        isFetching: Object.assign({}, isFetching),
      };
    }
  case LOAD_TAB_SUCCESS:
    {
      const { items: newFeedItemsForTab, tab: loadedTab } = action.payload;
      const { feedItems: oldFeedItems, isFetching } = state;
      const newFeedState = convertFeedItemsToStore(newFeedItemsForTab, oldFeedItems, loadedTab);

      isFetching[loadedTab.timelineKey] = false;

      const noMoreResults = {};
      noMoreResults[loadedTab.timelineKey] = (!newFeedItemsForTab || newFeedItemsForTab.length < 10);
      return {
        ...state,
        feedItems: newFeedState,
        isFetching: Object.assign({}, isFetching),
        ...{
          noMoreResults,
        },
      };
    }
  case FETCH_MORE_SUCCESS:
    {
      const { items: newFeedItemsForTab, tab: currentTab } = action.payload;

      const { feedItems: oldFeedItems, isFetching } = state;
      const newFeedState = convertFeedItemsToStore(newFeedItemsForTab, oldFeedItems, currentTab);

      isFetching[currentTab.timelineKey] = false;

      const noMoreResults = {};
      noMoreResults[currentTab.timelineKey] = (!newFeedItemsForTab || newFeedItemsForTab.length < 10);
      return {
        ...state,
        feedItems: newFeedState,
        isFetching: Object.assign({}, isFetching),
        ...{
          noMoreResults,
        },
      };
    }
  default:
    return state;
  }
}
